export const OPT_IN = {
    PAGE_DESCRIPTION:
        'To submit a request and receive updates from your provider,' +
        'Clarus will send you a one time pass code when you need to' +
        'verify your mobile device and a web link whenever your provider' +
        'replies to a request.',
    AGREE_CHECKBOX: 'I agree to receive pass codes and web links via SMS',
    FOOTER_DESCRIPTION:
        'Standard text messaging and data rates may apply.' +
        'To unsubscribe from SMS updates, reply STOP.' +
        'To start receiving SMS updates, reply START.' +
        'For instructions, reply HELP.',
    EXIT_DIALOG_TITLE: 'Submission Not Available',
    EXIT_DIALOG__MESSAGE_ONE:
        'This service requires SMS to send you updates about your request. If you do not want to use this service, you may also call the office at',
    EXIT_DIALOG__MESSAGE_TWO: '[310-657-1600]',
    EXIT_DIALOG_BUTTON: 'Try Again',
    PHONE_INPUT_LABEL: 'Enter Phone Number*',
};

export const OTP = {
    PAGE_DESCRIPTION:
        'Please verify your identify by entering the one time pass code sent to your mobile phone.',
    RESEND_MESSAGE: "Didn't receive the OTP?",
    RESEND_MESSAGE_LINK: 'Resend OTP',
};

export const STATUS = {
    STATUS_RECEIVED: 'Received',
    STATUS_REVIEWING: 'Reviewing',
    STATUS_COMPLETED: 'Completed',
    STATUS_RECEIVED_DESCRIPTION:
        'Your request has been successfully received and is being processed. Please wait for further updates.',
    STATUS_REVIEWING_DESCRIPTION:
        'Your request is currently under review, undergoing careful examination and evaluation.',
    STATUS_COMPLETED_DESCRIPTION:
        "Your request has been successfully processed. Please press the 'Read Reply' button to view the received message.",
};

export const PATIENTINFO = {
    PAGE_DESCRIPTION:
        'Please enter the patient’s information to properly handle the request.',

    FN_INPUT_LABEL: 'First Name*',
    LN_INPUT_LABEL: 'Last Name*',
    PHONE_INPUT_LABEL: 'Phone Number*',
    MESSAGE_INPUT_LABEL: 'Message*',
    DOB_INPUT_LABEL: 'Date of Birth',
    PROVIDER_INPUT_LABEL: 'Select Provider Name',
    GENDER_INPUT_LABEL: 'Select Gender',
    PHARMACY_INPUT_LABEL: 'Pharmacy Phone',
};

export const HOME = {
    WELCOME_MESSAGE: 'Connect with our office in a snap.',
    WELCOME_MESSAGE_LIST_ONE: 'Select the nature of your request.',
    WELCOME_MESSAGE_LIST_TWO: 'Submit your request details.',
    WELCOME_MESSAGE_LIST_THREE: 'Receive a response.',
};
export const REPLY_TIMER = {
    TIMER: 30,
};
export const REPLY = {
    MESSAGE:
        'I have sent a prescription to your pharmacy. Drink a lot of water and let me know if you’re not better in 1-2 days. Any emergency, please visit the nearest hospital.',
    EXPIRE_MESSAGE: `This reply will expire in ${REPLY_TIMER.TIMER} minutes.`,
    EXPIRE_MESSAGE_FOR_MULTIPLE: `The replies will expire ${REPLY_TIMER.TIMER} minutes after being read.`,
    EXPIRE_MESSAGE_STR: `The replies will expire {maxDuration} minutes after being read.`,
};

export const BUTTON_TEXT = {
    BUTTON_EXIT: 'Exit',
    BUTTON_CONTINUE: 'Continue',
    BUTTON_READ_REPLY: 'Read Reply',
    BUTTON_MAIN_MENU: 'Main Menu',
    BUTTON_VERIFY: 'Verify',
};

export const FOOTER = {
    LINK_PRIVACY: 'Privacy Policy',
    LINK_TOS: 'TOS',
    LINK_YEAR: `© ${new Date().getFullYear()} `,
};

export const HEADER = {
    HEADER_DEFAULT_NAME: 'Web Message App',
    HEADER_MESSAGE:
        'If this is a life-threatening emergency, dial 911 or go to your nearest emergency room.',
};

export const PAGE_TITLE = {
    OPTIN_TITLE: 'OTP Verification',
    OTP_TITLE: 'Verification Code',
    IVR_TITLE: 'Service Options',
    PATIENT_INFO: 'Patient Information',
    PROVIDER_REPLY: 'Provider Reply',
    REQUEST_STATUS: 'Request Status',
    PRIVACY: 'Privacy Policy',
    TOS: 'Terms of Services',
};

export const FORM_ERROR = {
    INVALID_PHONE: 'A phone number is not valid.',
    REQUIRED_PHONE: 'A phone number is required.',
    INCORRECT_PASS_CODE: 'Incorrect pass code.',
};

export const PRIVACY = {
    PAGE_TITLE: 'Privacy Policy of Clarus Care, LLC',
    SERVICE_DESCRIPTION:
        'Clarus Care, LLC. operates the claruscare.com website, which provides the SERVICE.',
    COLLECTION_POLICY:
        'This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service, the Privacy Act of 1974',
    POLICY_PDF_LINK:
        'https://claruscare.com/wp-content/uploads/2023/11/Privacy-Clarus.pdf',
    SERVICE_AGREEMENT:
        'If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.',
    SERVICE_TERM:
        'The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at claruscare.com, unless otherwise defined in this Privacy Policy.',
    INFO_COLLECTION_TITLE: 'Information Collection and Use',
    INFO_COLLECTION_DESCRIPTION:
        'For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you.',
    LOG_DATA: 'Log Data',
    LOG_DATA_DESCRIPTION:
        'We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer’s Internet Protocol (“IP”) address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.',
    COOKIES: 'Cookies',
    COOKIES_DESCRIPTION_ONE:
        'Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer’s hard drive.',
    COOKIES_DESCRIPTION_TWO:
        'Our website uses these “cookies” to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.',
    SERVICE_PROVIDERS: 'Service Providers',
    SERVICE_PROVIDERS_DESCRIPTION:
        'We may employ third-party companies and individuals due to the following reasons:',
    SERVICE_PROVIDERS_DESCRIPTION_ITEM_01: 'To facilitate our Service;',
    SERVICE_PROVIDERS_DESCRIPTION_ITEM_02:
        'To provide the Service on our behalf;',
    SERVICE_PROVIDERS_DESCRIPTION_ITEM_03:
        'To perform Service-related services; or',
    SERVICE_PROVIDERS_DESCRIPTION_ITEM_04:
        'To assist us in analyzing how our Service is used.',
    SERVICE_PROVIDERS_DESCRIPTION_TWO:
        'We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.',
    SECURITY: 'Security',
    SECURITY_DESCRIPTION:
        'We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.',
    TEXTING: 'Texting Terms of Use',
    TEXTING_DESCRIPTION_PART_01: 'Review our',
    TEXTING_DESCRIPTION_PART_02:
        'for information related to how we use SMS texting to operate our service and communicate with our customers.',
    LINK_OTHER_SITE: 'Links to Other Sites',
    LINK_OTHER_SITE_DESCRIPTION:
        'Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.',
    CHILDREN_PRIVACY: 'Children’s Privacy',
    CHILDREN_PRIVACY_DESCRIPTION:
        'Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.',
    CHANGE_POLICY: 'Changes to This Privacy Policy',
    CHANGE_POLICY_DESCRIPTION:
        'We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.',
    CONTACT: 'Contact Us',
    CONTACT_DESCRIPTION:
        'If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at ',
    CONTACT_DESCRIPTION_LINK: 'info@claruscare.com',
};

export const TOS_DATA = {
    PAGE_TITLE: 'Texting Terms of Use ',
    TITLE_DESCRIPTION:
        'This Texting Terms of Use applies when you give prior express consent to get text messages from Clarus Care (Clarus). Text messaging may include one-time or recurring texts related to the following programs:',
    TITLE_DESCRIPTION_LIST_01_TITLE: 'One-Time Passcode:',
    TITLE_DESCRIPTION_LIST_01:
        'During a password reset or confirming possession of your mobile device, your registered mobile phone number will be sent a code that is used to confirm your password change.',
    TITLE_DESCRIPTION_LIST_02_TITLE: 'Call Notifications:',
    TITLE_DESCRIPTION_LIST_02:
        'When you enable SMS as a notification method for new calls, you will be sent a' +
        'text message to your registered mobile phone number notifying you of a message in the OnCall app.',
    TITLE_DESCRIPTION_LIST_03_TITLE: 'Cover My Call Notifications:',
    TITLE_DESCRIPTION_LIST_03:
        'When you request changes to your call schedule using the ‘Cover My Call’ feature, you will be sent messages relating to the details and status of the request.',
    TITLE_DESCRIPTION_LIST_04_TITLE: 'Updates to a Patient Request:',
    TITLE_DESCRIPTION_LIST_04:
        'When messages are submitted online the provider may reply with a message. You will receive a message from Clarus with a link to view the message details securely on the web.  ',
    BY_ADDING_PHONE:
        'By adding your phone number to the Clarus Care service, you agree to receive text messages from Clarus. Message and data rates may apply. Message frequency varies. ',
    BY_ADDING_PHONE_DESCRIPTION:
        'We both agree that the only way to end text messages for a specific texting program is to reply STOP. You understand and approve that replying STOP to one texting program will not opt you out of all programs that you are enrolled in. Reply HELP to receive instruction on how to start and stop receiving messages.',
    BY_ADDING_PHONE_DESCRIPTION_ITEM_01:
        'Disabling notifications would cause the ability to change your password, receive passcodes, call notifications, use the Cover My Call feature, or online requests updates to not work. ',
    BY_ADDING_PHONE_DESCRIPTION_ITEM_02:
        'Call Notifications can also be stopped if you disable the SMS Notification option in your OnCall app Settings screen. ',
    BY_ADDING_PHONE_DESCRIPTION_ITEM_03:
        'One-Time Passcode and Cover My Call Notifications can also be disabled if you contact your Clarus system administrator and have your number removed. These two services require SMS messaging to operate. ',
    BY_ADDING_PHONE_DESCRIPTION_TWO:
        'Text messaging may not be available from all carriers.',
    NO_LONGER:
        'IF YOU NO LONGER WANT TEXT MESSAGES FROM US, YOU MUST REPLY STOP TO EACH TEXTING PROGRAM YOU ENROLLED IN.',
    NO_LONGER_DESCRIPTION_01:
        'After you send “STOP” to us, we will send you an SMS message confirming you no longer want to get text messages from that program. After this, you will no longer get text messages from us from that texting program. If you want to join again, send START to the program number where you previously unsubscribed.',
    NO_LONGER_DESCRIPTION_02:
        'We do not guarantee the successful delivery of text messages by your wireless provider. Messages sent by text may not be delivered if the mobile device is not in range of a transmission site, or if the network is down. Factors beyond the power of wireless carriers may get in the way of message delivery. This may include the terrain, how close you are to buildings, foliage, weather, and your equipment. We and your wireless provider will not be liable for losses or damages that come from:',
    NO_LONGER_DESCRIPTION_02_ITEM_01:
        'A message not delivered, a message delivered late, or ',
    NO_LONGER_DESCRIPTION_02_ITEM_02:
        'A message that goes to the wrong number; or ',
    NO_LONGER_DESCRIPTION_02_ITEM_03:
        'inaccurate or incomplete content in a text message.',
    NO_LONGER_DESCRIPTION_03:
        'We are not liable for your use or reliance on the content of any text message.',
    NO_LONGER_DESCRIPTION_04:
        'We can deliver messages to the following mobile phone carriers: Major carriers: AT&T, Verizon Wireless, Sprint, T-Mobile, MetroPCS, U.S. Cellular, Alltel, Boost Mobile, Nextel, and Virgin Mobile. Minor carriers: Alaska Communications Systems (ACS), Appalachian Wireless (EKN), Bluegrass Cellular, Cellular One of East Central IL (ECIT), Cellular One of Northeast Pennsylvania, Cincinnati Bell Wireless, Cricket, Coral Wireless (Mobi PCS), COX, Cross, Element Mobile (Flat Wireless), Epic Touch (Elkhart Telephone), GCI, Golden State, Hawkeye (Chat Mobility), Hawkeye (NW Missouri), Illinois Valley Cellular, Inland Cellular, iWireless (Iowa Wireless), Keystone Wireless (Immix Wireless/PC Man), Mosaic (Consolidated or CTC Telecom), Nex-Tech Wireless, NTelos, Panhandle Communications, Pioneer, Plateau (Texas RSA 3 Ltd), Revol, RINA, Simmetry (TMP Corporation), Thumb Cellular, Union Wireless, United Wireless, Viaero Wireless, and West Central (WCC or 5 Star Wireless). ***Carriers are not liable for delayed or undelivered messages*** ',
    NO_LONGER_DESCRIPTION_05:
        'If you have any questions about your text plan or data plan, it is best to contact your wireless provider. If you have questions about services or your plan, call the toll-free member number on your ID card. ',
    PRIVACY_AND_SECURITY: 'Privacy & security',
    PRIVACY_AND_SECURITY_DESCRIPTION_ONE:
        'Please update us right away if your mobile number changes. It is your responsibility to give a correct mobile number and to update any changes. If you don’t give us your new mobile number, we are not responsible for any text message sent to the wrong number. ',
    PRIVACY_AND_SECURITY_DESCRIPTION_TWO:
        'We recommend you use a password to open your mobile device. Text messages may include protected health information (PHI). Since text messaging is unencrypted, there is a risk that this PHI could be intercepted or viewed by third parties, including others who look at your device. When you choose to get text messages from us, you do so at your own risk. The use and disclosure of PHI in text messaging may be governed by other privacy notices, including applicable HIPAA Notice of Privacy Practices. ',
};

export const ERROR_MESSAGES = {
    WMA_DISABLED: 'Web messaging services are not enabled for this office.',
    EXPIRED_LINK: 'This link is no longer active or supported.',
    INVALID_URL:
        'The page you’re looking for doesn’t exist or the link is invalid.',
    SERVER_ERROR: 'Something went wrong on our end. Please try again later.',
    SESSION_TIMEOUT:
        'Your session has timed out due to inactivity. Please start again to continue.',
};

export const OPTIONS_FILTER = Object.freeze({
  ALL_ALLOWED: 'allAllowed',
  ONLY_NON_URGENT_ALLOWED: 'onlyNonUrgentAllowed',
  BLOCKED: 'blocked',
  OFFICE_HOURS_NOT_SET: 'officeHoursNotSet',
});

export const POPUP_CONFIG = Object.freeze({
  NON_URGENT_ALLOWED: {textKey : 'ERROR_URGENT_OPTIONS_UNAVAILABLE', showProceedButton: true, showExitButton: true},
  OFFICE_HOURS_NOT_SET: {textKey : 'ERROR_OFFICE_HOURS_NOT_SET', showProceedButton: false, showExitButton: false},
  BLOCKED: {textKey : 'ERROR_WEB_SUBMISSION_DISABLED', showProceedButton: false, showExitButton: true},
});